// utils.js
// ============== 配置模块 ==============
const COUNTRY_DATA = {
    korea: [

    ],
    asia: [

    ],
    south_east_asia: [
        { img_url: 'https://cdn.shopify.com/s/files/1/0754/7751/6543/files/Flag_Southeast_Asia_Vietnam.jpg?v=1765961376', name: 'Dzung Luxurious', url: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ftrung.dung.777701%2Fposts%2Fpfbid0356SdBpVxmraWeECapi49etRLEPFto1iQVTGKdKjy81ckVtzWrneRMW1jqUPJguxhl&show_text=true&width=500' },

    ],
    middle_east: [

    ],
    europe: [

    ],
    america: [
   
    ],
    russia: [

    ],
    australia: [
        { img_url: 'https://cdn.shopify.com/s/files/1/0754/7751/6543/files/Flag_Australia.jpg?v=1765961378', name: 'Dateline', url: 'https://www.datelineimports.com.au/beaver-anti-hair-loss-shampoo-704354' },
    ]
};

const CONFIG = {
    MAX_RETRIES: 10,           // 最大重试次数
    RETRY_INTERVAL: 1000,      // 重试间隔(ms)
    STORAGE_PREFIX: 'country_data_', // localStorage前缀
    TARGET_URL: window.location.origin + '/pages/shop_america'// 目标URL
};

// ============== 工具模块 ==============
const CountryUtils = {
    /**
     * 检查jQuery是否加载
     * @returns {boolean}
     */
    isJQueryLoaded: function () {
        return typeof jQuery !== 'undefined'
            && typeof jQuery.fn !== 'undefined'
            && typeof jQuery.fn.jquery !== 'undefined';
    },

    /**
     * 安全的JSON解析
     * @param {string} str - JSON字符串
     * @param {*} defaultValue - 默认值
     * @returns {*}
     */
    safeParseJSON: function (str, defaultValue = null) {
        try {
            return str ? JSON.parse(str) : defaultValue;
        } catch (e) {
            console.error('JSON解析失败:', e);
            return defaultValue;
        }
    },

    /**
     * 生成传输ID
     * @param {string} countryName - 国家名称
     * @returns {string}
     */
    generateTransferId: function (countryName) {
        return `${CONFIG.STORAGE_PREFIX}${countryName}`;
    },

    /**
     * 验证国家数据是否存在
     * @param {string} countryType - 国家类型
     * @returns {boolean}
     */
    validateCountryData: function (countryType) {
        if (!countryType) return false;
        return COUNTRY_DATA.hasOwnProperty(countryType.toLowerCase());
    },

    /**
     * 获取国家数据
     * @param {string} countryType - 国家类型
     * @returns {Array}
     */
    getCountryData: function (countryType) {
        if (!countryType) return [];
        const key = countryType.toLowerCase();
        return COUNTRY_DATA[key] || [];
    },

    /**
     * 保存数据到localStorage
     * @param {string} transferId - 传输ID
     * @param {Array} countries - 国家数据
     * @param {string} countryType - 国家类型
     * @returns {boolean}
     */
    saveToStorage: function (transferId, countries, countryType) {
        try {
            const storageData = {
                data: countries,
                source: window.location.href,
                timestamp: Date.now(),
                countryType: countryType
            };
            localStorage.setItem(transferId, JSON.stringify(storageData));
            return true;
        } catch (error) {
            console.error('保存到localStorage失败:', error);
            return false;
        }
    },

    /**
     * 获取目标URL
     * @param {string} transferId - 传输ID
     * @returns {string}
     */
    getTargetUrl: function (transferId) {
        return `${CONFIG.TARGET_URL}?transfer_id=${transferId}`;
    }
};

// 导出到全局作用域
window.COUNTRY_DATA = COUNTRY_DATA;
window.CONFIG = CONFIG;
window.CountryUtils = CountryUtils;




